import React, { Fragment, useState } from 'react';
import { FaEdit, FaEye, FaTrash } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import { TD } from 'styled/table';
import checkPermission from 'utils/checkPermission';
import permissions from 'utils/permissionConstants';
import DeleteContractType from './deleteContractType';
import EditContractType from './editContractType';

const ViewContractTypeList = ({ contractType, index }) => {
  const [showViewModel, setShowViewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [showDeleteModel, setShowDeleteModel] = useState(false);
  const currentUser = useSelector((state) => state.user.currentUser);
  return (
    <Fragment>
      <tr
        key={contractType._id}
        className={`${index % 2 !== 0 && 'bg-gray-100'}`}
      >
        <TD>{index + 1}</TD>
        <TD>{contractType.name}</TD>
        <TD>{contractType.code}</TD>
        <TD>
          {contractType.createdAt
            ? new Date(contractType.createdAt).toLocaleDateString("en-GB").replace(/\//g, '-')
            : ''}
        </TD>
        <TD>
          {checkPermission([permissions.manage_masters], currentUser) ? (
            <div className="">
              {/* <button
                onClick={() => setShowEditModel(true)}
                className="p-2 m-1  rounded-md bg-green-500 hover:bg-green-600 text-white"
              >
                <FaEdit />
              </button> */}
              <button
                onClick={() => setShowViewModel(true)}
                className="p-2 m-1 rounded-md bg-yellow-500 hover:bg-yellow-600 text-white"
              >
                <FaEye />
              </button>
              {/* <button
                onClick={() => setShowDeleteModel(true)}
                className="p-2  m-1 rounded-md bg-red-500 hover:bg-red-600 text-white"
              >
                <FaTrash />
              </button> */}
            </div>
          ) : (
            <p>----</p>
          )}
        </TD>
      </tr>
      {showViewModel && (
        <EditContractType
          data={contractType}
          desable={true}
          handleClick={() => setShowViewModel(false)}
        />
      )}
      {showEditModel && (
        <EditContractType
          data={contractType}
          handleClick={() => setShowEditModel(false)}
        />
      )}

      {showDeleteModel && (
        <DeleteContractType
          id={contractType._id}
          handleClick={() => setShowDeleteModel(false)}
        />
      )}
    </Fragment>
  );
};

export default ViewContractTypeList;